import { IProductGroupGuiModel, IProductGroupPutGuiModel } from "../model/IProductGroupGuiModel";
import ProductGroupService from "../service/ProductGroupService";
import { IProductGroupPutModel } from "../service/model/IProductGroupModel";
import { BusinessLogicDefaultResult, BusinessLogicResult } from "./BusinessLogicResult";

export default class ProductGroupBusinessLogic {

    public async getProductGroups(
        organizationId: string,
    ): Promise<BusinessLogicResult<IProductGroupGuiModel[]>> {

        const service = new ProductGroupService();
        const result = await service.getProductGroups(organizationId);

        if (result.hasErrors) {
            return new BusinessLogicResult([], result.errors);
        } else {
            let guiData: IProductGroupGuiModel[] = result.value.map(p => {
                return {
                    id: p.id,
                    name: p.name ? p.name : "",
                    vatId: p.vatId ? p.vatId.toString() : "",
                    taxableSales: p.taxableSales ? p.taxableSales.toString() : "",
                    taxableDiscount: p.taxableDiscount ? p.taxableDiscount.toString() : "",
                    nonTaxableSales: p.nonTaxableSales ? p.nonTaxableSales.toString() : "",
                    nonTaxableDiscount: p.nonTaxableDiscount ? p.nonTaxableDiscount.toString() : "",
                }

            });
            return new BusinessLogicResult(guiData, result.errors);
        }

    }
    public async postProductGroup(
        organizationId: string,
        name: string,
        vatId: string,
        taxableSales: string,
        taxableDiscount: string,
        nonTaxableSales: string,
        nonTaxableDiscount: string
    ): Promise<BusinessLogicDefaultResult> {

        if (parseInt(vatId) && parseInt(taxableSales) && parseInt(taxableDiscount) && parseInt(nonTaxableSales) && parseInt(nonTaxableDiscount)) {

            const service = new ProductGroupService();
            const result = await service.postProductGroups(
                organizationId,
                name,
                parseInt(vatId),
                parseInt(taxableSales),
                parseInt(taxableDiscount),
                parseInt(nonTaxableSales),
                parseInt(nonTaxableDiscount));

            if (result.hasErrors) {
                return new BusinessLogicDefaultResult(result.errors);
            } else {
                return new BusinessLogicDefaultResult([]);
            }

        } else {
            return new BusinessLogicResult([], ["One or more values from relevant inputfields are not numbers"]);
        }

        

    }
    public async putProductGroup(
        organizationId: string, id: number, data: IProductGroupPutGuiModel
    ): Promise<BusinessLogicDefaultResult> {

        const service = new ProductGroupService();

        let apiData: IProductGroupPutModel = {
            name: data.name ? { value: data.name.value } : undefined,
            vatId: data.vatId ? { value: parseInt(data.vatId.value) } : undefined,
            taxableSales: data.taxableSales ? { value: parseInt(data.taxableSales.value) } : undefined,
            taxableDiscount: data.taxableDiscount ? { value: parseInt(data.taxableDiscount.value) } : undefined,
            nonTaxableSales: data.nonTaxableSales ? { value: parseInt(data.nonTaxableSales.value) } : undefined,
            nonTaxableDiscount: data.nonTaxableDiscount ? { value: parseInt(data.nonTaxableDiscount.value) } : undefined,
        }

        const result = await service.putProductGroup(organizationId, id, apiData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }

    }
}